import * as ExcessUtil from 'notebook/tables/excess/Util';
import {CustomEvalResult, TypedValue} from 'notebook/tables/TableConstants';
import {coerceToPrimitiveNumber, isTypedValueEmpty} from 'notebook/tables/typed-values/DataTypes';

const PURITY_RANGE_ERROR = 'Purity must be a number between 0 and 100%.';

export function getMoleculePurityColumnCustomEval(typedValue: TypedValue): CustomEvalResult {
  if (isTypedValueEmpty(typedValue)) {
    return {val: typedValue, error: new ExcessUtil.ValueError(PURITY_RANGE_ERROR), locked: false};
  }
  const numericValue = coerceToPrimitiveNumber(typedValue);
  if (numericValue == null || numericValue <= 0 || numericValue > 100) {
    return {val: typedValue, error: new ExcessUtil.ValueError(PURITY_RANGE_ERROR), locked: false};
  }
  return {val: typedValue, error: null, locked: false};
}
